// extracted by mini-css-extract-plugin
export default {"wrapper":"PNe8TksGmKeM1_Mraz0_","breadcrumb":"w9nFE6uUxj3156BeE2aa"};